import { RouteRecordRaw } from "vue-router";
import { HOME_URL } from "@/config";

const staticRouter: RouteRecordRaw[] = [
    // TODO 首页路径待调整
    {
        path: "/",
        redirect: HOME_URL
    },
    {
        path: "/login",
        name: "Login",
        meta: { title: "登录" },
        component: () => import("@/views/pages/login/index.vue")
    },
    {
        path: "/403",
        name: "403",
        component: () => import("@/views/pages/errorMessage/403.vue"),
        meta: {
            title: "403页面"
        }
    },
    {
        path: "/404",
        name: "404",
        component: () => import("@/views/pages/errorMessage/404.vue"),
        meta: {
            title: "404页面"
        }
    },
    // Resolve refresh page, route warnings
    {
        path: "/:pathMatch(.*)*",
        name: "matchAll",
        component: () => import("@/views/pages/errorMessage/404.vue")
    }
];

export default staticRouter;
